// RoundedCheckbox.jsx
import React from "react";
import { Checkbox, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";

const boxStyle = {
  width: 14,
  height: 14,
  border: "1px solid",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const CustomCheckbox = (props) => {
  return (
    <Checkbox
      {...props}
      icon={
        <Box
          sx={{
            ...boxStyle,
            borderColor: "var(--color-h3)",
          }}
        />
      }
      checkedIcon={
        <Box
          sx={{
            ...boxStyle,
            borderColor: "var(--color-h3)",
            color: "var(--color-h3)",
          }}
        >
          <CheckIcon sx={{ fontSize: 12 }} />
        </Box>
      }
      indeterminateIcon={
        <Box
          sx={{
            ...boxStyle,
            borderColor: "var(--color-h3)",
            color: "var(--color-h3)",
          }}
        >
          <RemoveIcon sx={{ fontSize: 12 }} />
        </Box>
      }
    />
  );
};

export default CustomCheckbox;
